import { chooseAmongstUnAggHourlyAndDaily } from '../../../../chooseAmongstUnAggHourlyAndDaily'

export const getBlankSeriesInterval = () => {
  let interval = 60 * 60 * 1000

  const intervalToRequest = chooseAmongstUnAggHourlyAndDaily()

  switch (intervalToRequest) {
    case 'HOURLY':
      interval = 60 * 60 * 1000

      break

    case 'DAILY':
      interval = 24 * 60 * 60 * 1000

      break

    case 'UNAGGREGATED':
      interval = 10 * 60 * 1000

      break

    default:
      break
  }

  return interval
}
